import React from "react";
import styled from "styled-components";
import { ReactComponent as Cross } from "./../../atoms/icons/cross.svg";

const LabelWrap = styled.div`
  display: inline-block;
  margin: 0 4px 8px;
  width: calc(50% - 8px);

  @media(min-width: 1200px) {
    width: calc(25% - 8px);
  }

  @media (max-width: 1200px) and (min-width: 990px) {
     width: calc(33% - 8px);
   }
`;

const Input = styled.input`
  display: none;

  &:checked + label {
    background-color: var(--color-primary);
    border: 1px solid var(--color-primary);
    color: #fff;

    svg {
      opacity: 1;
    }
  }
`;

const Label = styled.label`
  display: block !important;
  height: 40px;
  position: relative;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 3px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: var(--color-secondary);
  cursor: pointer;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 40px;
  line-height: 23px;

  svg {
    opacity: 0;
    position: absolute;
    ${(props) => {
      if (props.bigCloseBtn) {
        return `
            height: 17px;
            width: 15px;
            right: 14px;
            top: 21px;
              @media (max-width: 768px) {
                height: 12px;
                width: 12px;
                right: 6px;
                top: 23px;
                color: white;
              }
        `;
      }
      return `
            top: 12px;
            right: 6px;
        `;
    }}
  }
`;

const LabelSelector = (props) => {
    let reference = false;
    const { text, selectedExclusions, exclusionChange, bigCloseBtn } = props;
    const name = text.toLowerCase().replace(/\s/g, "-");
    const handleOnChange = function (e) {
        exclusionChange(e, reference);
    };
    const checkboxStatus = function () {
        let status = false;
        if (!selectedExclusions.length) return status;
        selectedExclusions.forEach((item) => {
            if (item.toLowerCase() === text.toLowerCase()) {
                status = true;
                return false;
            }
        });

        return status;
    };

    return (
        <LabelWrap key={props.id} className="label-wrap">
            <Input
                type="checkbox"
                id={"label-" + name}
                name={name}
                value={text}
                onChange={handleOnChange}
                ref={(input) => {
                    reference = input;
                }}
                checked={checkboxStatus()}
            />
            <Label htmlFor={"label-" + name} bigCloseBtn={bigCloseBtn}>
                {text}
                <Cross />
            </Label>
        </LabelWrap>
    );
};

export default LabelSelector;
